// extracted by mini-css-extract-plugin
module.exports = {"description":"style_description__hKyXi","questionNumber":"style_questionNumber__2X4El","section":"style_section__3cMdo","invalidValue":"style_invalidValue__1L9hN"};